import {
  Toast,
  ToastFooter,
  ToastIntent,
  ToastTitle,
  ToastTrigger
} from "@fluentui/react-components";
import {
  CheckmarkCircle20Regular,
  Dismiss20Regular,
  ErrorCircle20Regular,
  Info20Regular,
  Warning20Regular
} from "@fluentui/react-icons";
import { useNavigate } from "react-router";

import { ToastNotification } from "store/slices/toastNotificationSlice";

import "./ToasterNotification.scss";

type Props = {
  message: ToastNotification;
  onDismiss: (id: string) => void;
  notificationActionLink?: string;
  notificationActionText?: string;
};

export function NotificationToast({
  message,
  onDismiss,
  notificationActionLink,
  notificationActionText = ""
}: Props) {
  const navigate = useNavigate();

  const { type: intent, message:text } = message;

  const renderIcon = (type: ToastIntent) => {
    switch (true) {
      case type === "success":
        return <CheckmarkCircle20Regular className="notification-success" />;
      case type === "error":
        return <Warning20Regular className="notification-error" />;
      case type === "warning":
        return <ErrorCircle20Regular className="notification-warning" />;
      default:
        return <Info20Regular className="notification-info" />;
    }
  };


  return (
    <Toast className={`${intent}-color`}>
      <ToastTitle
        media={renderIcon(intent)}
        action={
          <ToastTrigger>
            <Dismiss20Regular onClick={() => onDismiss(message.id)} />
          </ToastTrigger>
        }
      >
        <div className="d-flex align-items-center">
          <span className="me-2">
            {text}
          </span>
        </div>
      </ToastTitle>
      {notificationActionLink && notificationActionText && (
        <ToastFooter>
          <span
            onClick={() => navigate(notificationActionLink)}
            className="blue-link"
          >
            {notificationActionText}
          </span>
        </ToastFooter>
      )}
    </Toast>
  );
}
